import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import i18n from '../../../i18n';
import { MenuItem } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';

const MultipleSelect = ({
    selectedItems,
    items,
    handleChange,
    label,
    trKey,
    helperText,
    disabled
}) => {
    const translateOption = (option, translateKey) =>
        option ? i18n.t(`${translateKey}.${option}`) : '';

    return (
        <Select
            multiple
            disabled={disabled}
            value={selectedItems}
            onChange={(event) => handleChange(event.target.value)}
            input={
                <OutlinedInput
                    label={label}
                    helperText={helperText}
                />
            }
            renderValue={(selected) =>
                selected.map((el) => translateOption(el, trKey)).join(', ')
            }
        >
            {items.length
                ? items.map((item) => (
                    <MenuItem key={item} value={item} id={item}>
                        <Checkbox
                            checked={selectedItems.indexOf(item) > -1}
                        />
                        <ListItemText
                            primary={translateOption(item, trKey)}
                        />
                    </MenuItem>
                ))
                : null}
        </Select>
    );
};

export default MultipleSelect;
